import React from 'react';
import Icon from '../../../components/openplay/OpenPlayIcon';
import AppImage from '../../../components/openplay/OpenPlayImage';

const InquirySection = ({ inquiries, onAskQuestion }) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-base font-semibold text-foreground flex items-center gap-2">
          <Icon name="ChatBubbleLeftRightIcon" size={20} className="text-primary" />
          문의 사항
        </h3>
        <button
          onClick={onAskQuestion}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium text-primary hover:bg-primary/10 transition-smooth touch-target"
          type="button"
        >
          <Icon name="PlusIcon" size={16} />
          질문하기
        </button>
      </div>

      {inquiries.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12 px-4 rounded-lg bg-muted">
          <Icon name="ChatBubbleLeftRightIcon" size={48} className="text-muted-foreground mb-3" />
          <p className="text-sm text-muted-foreground text-center caption">
            아직 문의가 없습니다.\n궁금한 점을 질문해보세요!
          </p>
        </div>
      ) : (
        <div className="space-y-4">
          {inquiries.map((inquiry) => (
            <div key={inquiry.id} className="p-4 rounded-lg bg-muted space-y-3">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background flex-shrink-0">
                  <AppImage src={inquiry.userAvatar} alt={inquiry.userAvatarAlt} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <p className="text-sm font-semibold text-foreground">{inquiry.userName}</p>
                    <span className="text-xs text-muted-foreground caption">{inquiry.timestamp}</span>
                  </div>
                  <p className="text-sm text-foreground">{inquiry.question}</p>
                </div>
              </div>

              {inquiry.answer && (
                <div className="ml-13 pl-4 border-l-2 border-primary">
                  <div className="flex items-center gap-2 mb-1">
                    <Icon name="CheckBadgeIcon" variant="solid" size={16} className="text-primary" />
                    <p className="text-xs font-semibold text-primary caption">주최자 답변</p>
                  </div>
                  <p className="text-sm text-foreground">{inquiry.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default InquirySection;
